import styled from 'styled-components';

const ActionsContainer = styled.div`
  display: inline-flex;
  align-items: flex-start;
  gap: 12px;
`;

export default ActionsContainer;
